var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconCommittees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.441,
    height: 19,
    viewBox: "0 0 21.441 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu_Icon_Committees",
    transform: "translate(-7 -30.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10814",
    "data-name": "Group 10814",
    transform: "translate(10.503 30.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36374",
    "data-name": "Path 36374",
    d: "M49.342,47.765l.213-.428H48.7l.215.428-.049.69a.65.65,0,0,1,.528,0l-.049-.69Z",
    transform: "translate(-37.477 -41.529)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36375",
    "data-name": "Path 36375",
    d: "M42.583,52.3V49.049A1.717,1.717,0,0,1,44.3,47.336l.332,1.33a.809.809,0,0,0-.161.486.8.8,0,0,0,.171.5v1.282H42.977L42.749,52.3h-.167Z",
    transform: "translate(-33.502 -41.529)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36376",
    "data-name": "Path 36376",
    d: "M51.73,47.336a1.719,1.719,0,0,1,1.713,1.713V52.3h-.167l-.229-1.371H51.387V49.651a.8.8,0,0,0,.171-.5.809.809,0,0,0-.161-.486l.332-1.33Z",
    transform: "translate(-39.223 -41.529)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36377",
    "data-name": "Path 36377",
    d: "M46.744,35.1a1.941,1.941,0,1,1-1.713,1.928A1.83,1.83,0,0,1,46.744,35.1Z",
    transform: "translate(-35.094 -33.582)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36378",
    "data-name": "Path 36378",
    d: "M44.226,58.586H48l.171,1.028H44.055Z",
    transform: "translate(-34.46 -48.838)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36379",
    "data-name": "Path 36379",
    d: "M49.288,51.348a.382.382,0,0,1,.342.412.43.43,0,0,1-.171.356v1.426h-.342V52.116a.43.43,0,0,1-.171-.356.382.382,0,0,1,.342-.412Z",
    transform: "translate(-37.637 -44.136)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36380",
    "data-name": "Path 36380",
    d: "M17.152,50.937V49.053a1.717,1.717,0,0,1,1.713-1.713l.3,1.195a.811.811,0,0,0-.252,1.045l-.239,1.36h-1.52Z",
    transform: "translate(-16.98 -41.531)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36381",
    "data-name": "Path 36381",
    d: "M24.744,38.916a.76.76,0,0,1-.067.066l-.119.679-.059.331-.03.171h1.719v1.371h.857v-2.37c0-2.374,1.7-3.309,1.7-4.58V31.527a.769.769,0,1,0-1.538,0v2.715c0,.368-1.149,2.321-1.875,2.321l-.408,1.628a.814.814,0,0,1,.008.326.835.835,0,0,1-.114.3l0,0v0l0,0v0l0,0v0l0,0v0l0,0v0l0,0v0l0,0v0l-.052.052-.007.008h0Z",
    transform: "translate(-21.734 -30.758)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36382",
    "data-name": "Path 36382",
    d: "M23.905,47.765l.213-.428h-.857l.215.428-.047.658a.633.633,0,0,1,.175.007.642.642,0,0,1,.363.2l-.062-.863Z",
    transform: "translate(-20.95 -41.529)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36383",
    "data-name": "Path 36383",
    d: "M21.31,35.1a1.941,1.941,0,0,1,0,3.856,1.941,1.941,0,0,1,0-3.856Z",
    transform: "translate(-18.569 -33.582)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36384",
    "data-name": "Path 36384",
    d: "M23.04,51.414a.381.381,0,0,1,.265.464.431.431,0,0,1-.23.322l-.244,1.382h-.348l.255-1.442a.43.43,0,0,1-.107-.38.382.382,0,0,1,.409-.345Z",
    transform: "translate(-20.444 -44.176)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36385",
    "data-name": "Path 36385",
    d: "M17,58.586h3.77v1.028H16.661Z",
    transform: "translate(-16.661 -48.838)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36392",
    "data-name": "Path 36392",
    d: "M86.195,83.043h1.371v.686H86.195Z",
    transform: "translate(-60.178 -33.97)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36393",
    "data-name": "Path 36393",
    d: "M9.891,83.043h1.371v.686H9.891Z",
    transform: "translate(-1.878 -33.97)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36394",
    "data-name": "Path 36394",
    d: "M5.466,62.5H25.975l.466,6.854H5Z",
    transform: "translate(2 -20.623)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconCommittees);
export default __webpack_public_path__ + "static/media/Menu_Icon_Committees.3c050ff3.svg";
export { ForwardRef as ReactComponent };